import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { Box, Typography } from '@mui/material';

import i18n from 'shared/lib/i18n';

import { getIsLoading } from '../Shared/selectors';
import { getExternalAccountsSchema } from './selectors';

import StyledLink from '../StyledLink';
import { ExternalAccountsSkeleton } from './ExternalAccountsSkeleton';

const formatSchema = (externalAccountsSchema, pathname) => {
  if (!externalAccountsSchema) return [];
  const { enabled, types, subtypes } = externalAccountsSchema;
  if (!enabled) return [];
  const schema = types?.map(({ value, name: groupName }) => {
    const accounts = subtypes
      ?.filter(({ type }) => type === value)
      ?.map(({ name, subtype }) => ({
        accountName: name,
        accountLink: `${pathname}/${subtype}`,
      }));
    return {
      groupName,
      accounts,
    };
  });

  // external links integration is not an external account and is not in the schema
  // but should be displayed as one of the external accounts
  schema.push({
    groupName: i18n.t('title.customIntegrations'),
    accounts: [
      {
        accountName: i18n.t('title.customExternalLinks'),
        accountLink: `${pathname}/external-links`,
      },
    ],
  });

  return schema;
};

export const ExternalAccountsList = () => {
  const location = useLocation();
  const isLoading = useSelector(getIsLoading);
  const externalAccountsSchema = useSelector(getExternalAccountsSchema);

  if (isLoading && !externalAccountsSchema) {
    return <ExternalAccountsSkeleton />;
  }

  const schema = formatSchema(externalAccountsSchema, location.pathname);

  return (
    <Box>
      {schema?.map(({ groupName, accounts }) => (
        <Box key={groupName}>
          <Typography variant="h5">{groupName}</Typography>
          <Box sx={{ m: '1rem 0 3rem 2rem' }}>
            {accounts?.map(({ accountName, accountLink }) => (
              <Typography
                component="div"
                style={{ fontSize: '1.8rem' }}
                key={accountName}
              >
                <StyledLink to={accountLink}>{accountName}</StyledLink>
              </Typography>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
